import React from 'react';
import { Badge } from './ui/badge';
import { getStatusConfig } from '../lib/statusUtils';

export const StatusBadge = ({ status }) => {
  const config = getStatusConfig(status);
  const isAnimating = status?.includes('generating') || status === 'video_rendering';

  return (
    <Badge
      className={`${config.bgClass} border gap-1.5 font-medium text-[11px] px-2 py-0.5`}
      data-testid="project-status-badge"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dotClass} ${isAnimating ? 'animate-pulse-dot' : ''}`} />
      {config.label}
    </Badge>
  );
};
